export default "/static/media/icon-map.800521dd.svg";